import type { Restaurant } from "~/models";

/**
 * Each moment of the day.
 */
export enum Moment {
  Evening = "soir",
  Lunch = "midi",
  Morning = "matin"
}
